import React from "react"
import { useSelector } from "react-redux"

import { QidDatapoint } from "server/models"
import { StoreType } from "client/store"
import {
    TableColumn,
    Empty,
    // DateFormatter,
} from "client/components"

const Columns = (isNested: boolean) => {
    const lang = useSelector((state: StoreType) => state.system.lang)

    const columns: TableColumn[] = [
        {
            field: "reference",
            header: lang.reference,
            cellMinWidth: "200px",
            cellMaxWidth: "400px",
            formatter: (datapoint: QidDatapoint) => {
                if (datapoint.datapointId) return null // don't display for nested rows
                if (!datapoint.reference) return <Empty />

                const { revision, file } = datapoint.reference
                const title = `${file.name} - rev. ${revision}`
                return <span title={title}>{title}</span>
            },
        },
        /* >>> temporarily disabled <<<
        {
            field: "publicationDate",
            header: lang.publicationDate,
            cellMinWidth: "200px",
            cellMaxWidth: "200px",
            formatter: (datapoint: QidDatapoint) => {
                if (datapoint.datapointId !== null) return null
                return <DateFormatter date={datapoint.publicationDate} showTime={false} />
            },
        },
        */
    ]

    if (isNested) {
        columns.push({
            field: "failureMode",
            header: lang.failureMode,
            cellMinWidth: "200px",
            formatter: (datapoint: QidDatapoint) => datapoint.failureMode && (
                <span title={datapoint.failureMode.name}>
                    {datapoint.failureMode.name}
                </span>
            ),
        })
    }

    columns.push(
        {
            field: "sd",
            header: "SD",
            cellMinWidth: "100px",
            formatter: (datapoint: QidDatapoint) => datapoint.sd || <Empty />,
        },
        {
            field: "su",
            header: "SU",
            cellMinWidth: "100px",
            formatter: (datapoint: QidDatapoint) => datapoint.su || <Empty />,
        },
        {
            field: "dd",
            header: "DD",
            cellMinWidth: "100px",
            formatter: (datapoint: QidDatapoint) => datapoint.dd || <Empty />,
        },
        {
            field: "du",
            header: "DU",
            cellMinWidth: "100px",
            formatter: (datapoint: QidDatapoint) => datapoint.du || <Empty />,
        },
        {
            field: "ne",
            header: "NE",
            cellMinWidth: "100px",
            formatter: (datapoint: QidDatapoint) => datapoint.ne || <Empty />,
        },
        {
            field: "np",
            header: "NP",
            cellMinWidth: "100px",
            formatter: (datapoint: QidDatapoint) => datapoint.np || <Empty />,
        },
    )

    return columns
}
export default Columns
